'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getSchemaMarkup } from '@/utils/schemaMarkup';

export default function DynamicHead() {
  const pathname = usePathname();
  const jsonLdSchema = getSchemaMarkup(pathname);
  const [showNoIndex, setShowNoIndex] = useState(false);

  useEffect(() => {
    setShowNoIndex(window.location.hostname !== 'heraflight.com');
  }, []);

  return (
    <>
      <script
        id="schema-markup"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonLdSchema),
        }}
      />
      {showNoIndex && <meta name="robots" content="noindex" />}
    </>
  );
}
